import { AfterViewInit, Component, ElementRef, HostBinding, Renderer2, inject, input } from '@angular/core';

/* eslint-disable @angular-eslint/component-selector */
@Component({
  selector: '[sb-badge]',
  template: '<ng-content />',
  standalone: false, // eslint-disable-line
})
export class BadgeComponent implements AfterViewInit {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  color = input<'primary' | 'accent' | 'info' | 'danger' | 'success' | 'basic'>('basic', {
    alias: 'sb-badge',
  });

  @HostBinding('class') get classList() {
    return `tw-rounded-lg tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-whitespace-nowrap ${this.getColorClasses()}`;
  }

  ngAfterViewInit() {
    this.capitalizeFirstLetterAndAddPadding();
  }

  private capitalizeFirstLetterAndAddPadding() {
    const element = this.el.nativeElement;
    const childNodes = element.childNodes;

    if (childNodes.length > 0) {
      const firstNode = childNodes[0];

      if (firstNode && firstNode.nodeType !== Node.TEXT_NODE && firstNode.nodeType !== Node.COMMENT_NODE) {
        this.renderer.setStyle(firstNode, 'marginRight', '0.25rem');
      }

      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
      let textNode = walker.nextNode();

      while (textNode) {
        const text = textNode.textContent?.trim();
        if (text && text.length > 0) {
          const capitalizedText = text.charAt(0).toUpperCase() + text.slice(1);
          this.renderer.setProperty(textNode, 'textContent', capitalizedText);
          break;
        }
        textNode = walker.nextNode();
      }
    }
  }

  private getColorClasses() {
    switch (this.color()) {
      case 'primary':
        return 'tw-bg-primary-100 tw-text-primary-500';
      case 'accent':
        return 'tw-bg-accent-100 tw-text-accent-500';
      case 'info':
        return 'tw-bg-warn-100 tw-text-warn-500';
      case 'danger':
        return 'tw-bg-danger-100 tw-text-danger-500';
      case 'success':
        return 'tw-bg-success-100 tw-text-success-600';
      case 'basic':
      default:
        return 'tw-bg-gray-100 tw-text-gray-500';
    }
  }
}
